export default __webpack_public_path__ + "static/media/20-EXT-(3-2).d38817ab.jpg";